import React from "react";
import styled from "styled-components";
import Img from "gatsby-image";
import HoverTile from "./HoverTile";

const Styled = {};
Styled.Tile = styled.div`
  .thr-p {
    padding: 2vh;
  }
`;

export const rejig2020Title = (title) =>
  title.replace("2020 ", "").replace("2020: ", "");

export const Tile = ({ topic, chapter, blue }) => {
  const { jumpText, squareImage, slug, title } = topic;
  const { json } = jumpText ? jumpText : { json: null };
  const { fixed } = squareImage ? squareImage : { fixed: null };

  return (
    <Styled.Tile
      style={{
        position: "relative",
        display: "inline-block",
        marginBottom: "20px",
      }}
      blue={blue}
    >
      {fixed && (
        <Img
          fixed={fixed}
          alt={squareImage.title}
          style={{ height: "400px", width: "400px" }}
        />
      )}
      <div
        style={{
          position: "absolute",
          height: "400px",
          width: "400px",
          top: 0,
          left: 0,
        }}
      >
        <HoverTile
          title={rejig2020Title(title)}
          json={json}
          slug={chapter ? chapter + "/" + slug : slug}
          vanish
        />
      </div>
    </Styled.Tile>
  );
};
